module.exports = __webpack_public_path__ + "resource/img/image005Dark.c49e7c18.png";